import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import { PayloadStates } from '@lore/utils';
import MissingField from '@/pages/project-manage/MissingField';
import HiddenField from '@/pages/project-manage/HiddenField';
import useMissingFields from './useMissingFields';

export default function MissingFields(props) {
  const { event } = props;

  const { missingFields } = useMissingFields(event);

  if (missingFields.state === PayloadStates.FETCHING) {
    return null;
  }

  if (
    missingFields.data.length > 0
  ) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {missingFields.data.map(function(missingField) {
          return (
            <MissingField
              key={missingField.key}
              name={missingField.name}
              description={(
                <>
                  You must provide this field before you can connect with partners,
                  or before your event will be shown to others.
                </>
              )}
              to={missingField.to}
            />
          );
        })}
      </div>
    );
  }

  const inPast = (
    event.data.specificDate === 'Yes' &&
    isExpired(event.data.date)
  ) || (
    isExpired(event.data.endDate)
  );

  if (inPast) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <HiddenField
          name="Your event has expired!"
          description={(
            <>
              Partners can no longer see your event because it&apos;s set in the
              past. Change the date to make it visible again.
            </>
          )}
          to={`/post-event/${event.id}/date`}
        />
      </div>
    );
  }

  return null;
};

MissingFields.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      specificDate: PropTypes.string,
      date: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string
    })
  }).isRequired
};
